function checkArray(viewFilter, underlyings) {
  let hasMatchingValues = false;

  for (let index = 0; index < underlyings.length; index++) {
    const element = underlyings[index];

    if (viewFilter.includes(element)) {
      hasMatchingValues = true;
      break;
    }
  }

  return hasMatchingValues;
}

export function viewUnderlyingSymbols(data, underlyingSymbols) {
  let newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (underlyingSymbols.includes(null) && !element.underlyings.length) {
      newData.push(element);
      continue;
    }

    if (
      element.underlyings.length &&
      checkArray(underlyingSymbols, element.underlyings)
    ) {
      newData.push(element);
      continue;
    }
  }

  return [...newData];
}
